module.exports = __webpack_public_path__ + "img/NoImage.060ecfb3.png";